import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=880112dc&scoped=true&"
import script from "./PDF.vue?vue&type=script&lang=js&"
export * from "./PDF.vue?vue&type=script&lang=js&"
import style0 from "./PDF.vue?vue&type=style&index=0&id=880112dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880112dc",
  null
  
)

export default component.exports